import React from 'react'
import "./Services.css";
// import Robotics from "../../assets/images/robotics.png";
// import AI from "../../assets/images/AI.png";
// import STEM from "../../assets/images/stem.png";
// import IoT from "../../assets/images/IOT.png";
// import ATL from "../../assets/images/ATL.png";
// import PMSHRI from "../../assets/images/pmshri.png";
// import ai_icon from "../../assets/images/ai-icon.png";
// import robotics_icon from "../../assets/images/robotics-icon.png";
// import stem_icon from "../../assets/images/stem-icon.png";
// import iot_icon from "../../assets/images/iot-icon.png";
// import atl_icon from "../../assets/images/atl-icon.png";
// import pmshri_icon from "../../assets/images/pm-shri-icon.png";
// import { Link } from 'react-router-dom';
import Tittle from '../Title/Tittle';
import Nav from '../navbar/Nav';
import Footer from '../footer/Footer';
import ScienceLabs from "../../assets/images/science-labs.png";
import ScienceCenters from "../../assets/images/science-centers.png";
import TelescopeLenses from "../../assets/images/custom-telescope-lenses.png";
import ArVR from "../../assets/images/ar-vr.png";
import AstronomyLabs from "../../assets/images/astronomy-labs.png";
import AstrophysicsLabs from "../../assets/images/astrophysics-labs.png";
import DigitalLibrary from "../../assets/images/digital-library.png";
import DesignThinkinLab from "../../assets/images/design-thinking-lab.png";
import GeographyLab from "../../assets/images/geography-lab.png";
const OurServices = () => {
  return (
    <div>
        <Nav/>
    <div className="container">
        <Tittle subTitle='Our Services' title='What We Offer'/>
    <div className='services'>
      <div className='service'>
            <img src={ScienceLabs} alt='robotics'/>
        <div className='caption'>
          {/* <Link to='/'>
            <img src={robotics_icon} alt=''/>
          </Link> */}
          <p>Science Labs</p>
        </div>
      </div>
      <div className='service'>
        <img src={ScienceCenters} alt='ai' Link to='home'/>
        <div className='caption'>
          {/* <Link to='/'>
          <img src={ai_icon} alt=''/>
          </Link> */}
          <p>Science Centers</p>
        </div>
      </div>
      <div className='service'>
        <img src={TelescopeLenses} alt='stem'/>
        <div className='caption'>
          {/* <Link to='/'>
          <img src={stem_icon} alt=''/>
          </Link> */}
          <p>Custom Telescope Lenses</p>
        </div>
      </div>
    </div>

    <div className='services'>
      <div className='service'>
        <img src={ArVR} alt='iot'/>
        <div className='caption'>
          {/* <Link to='/'>
          <img src={iot_icon} alt=''/>
          </Link> */}
          <p>AR-VR Lab</p>
        </div>
      </div>
      <div className='service'>
        <img src={AstronomyLabs} alt='atl'/>
        <div className='caption'>
          {/* <Link to='/'>
          <img src={atl_icon} alt=''/>
          </Link> */}
          <p>Astronomy Labs</p>
        </div>
      </div>
      <div className='service'>
        <img src={AstrophysicsLabs} alt='stem'/>
        <div className='caption'>
          {/* <Link to='/'>
          <img src={pmshri_icon} alt=''/>
          </Link> */}
          <p>Astrophysics Labs</p>
        </div>
      </div>
    </div>
    <div className='services'>
      <div className='service'>
            <img src={DigitalLibrary} alt='robotics'/>
        <div className='caption'>
          {/* <Link to='/'>
            <img src={robotics_icon} alt=''/>
          </Link> */}
          <p>Digital Library</p>
        </div>
      </div>
      <div className='service'>
        <img src={GeographyLab} alt='ai' Link to='home'/>
        <div className='caption'>
          {/* <Link to='/'>
          <img src={ai_icon} alt=''/>
          </Link> */}
          <p>Geography Lab</p>
        </div>
      </div>
      <div className='service'>
        <img src={DesignThinkinLab} alt='stem'/>
        <div className='caption'>
          {/* <Link to='/'>
          <img src={stem_icon} alt=''/>
          </Link> */}
          <p>Design & Thinking Lab</p>
        </div>
      </div>
    </div>
        <Footer/>
    </div>
    </div>
  )
}

export default OurServices
